import classNames from 'classnames';
import 'swiper/css/pagination';
import { fixedForwardRef } from '~/components/Util/react';
import styles from './CarouselPagination.module.scss';

export type CarouselPaginationProps = {
  className?: string;
};
export const CarouselPagination = fixedForwardRef<HTMLDivElement, CarouselPaginationProps>(
  ({ className }, ref) => <div className={classNames(styles.root, className)} ref={ref} />
);
